import { cn } from '@/utils/styles';
import { useEffect, useRef } from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, type ButtonProps } from '@design-system/Button';

export interface ReturnButtonProps extends Omit<ButtonProps, 'onClick'> {
  hideLabel?: boolean;
  onClick?: () => void;
}

export const ReturnButton = ({
  hideLabel,
  className,
  children = 'Back',
  onClick,
  ...rest
}: ReturnButtonProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromRef = useRef('');

  const handleOnReturn = () => {
    if (onClick) {
      onClick();
      return;
    }

    const from = fromRef.current;
    if (!from) return navigate(-1);

    navigate(from, { replace: true });
  };

  useEffect(() => {
    fromRef.current = location.state?.from?.pathname;
  }, []);

  return (
    <Button
      variant="link"
      {...rest}
      onClick={handleOnReturn}
      className={cn(
        'p-0 md:p-2 [&_svg]:size-6 text-primary typography-btn-large',
        className,
      )}
    >
      <ChevronLeftIcon size={24} />
      {!hideLabel && <span className="hidden md:block">{children}</span>}
    </Button>
  );
};
